import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { DialogManager } from "../../Managers/DialogManager";
import { ApplicationData } from "../ApplicationData";

export class PrintBase {
  constructor(options) {
    options = options || {};
    this.isOpen = false;

    this.frameID = options.frameID || "printFrame";
    this.frameClass = options.frameClass || "printFrame";

    this.printFrame =
      '<iframe class="' +
      this.frameClass +
      '" id="' +
      this.frameID +
      '"></iframe>';
    this.popUpWindow = null;

    this.dialogTitle = options.dialogTitle || ApplicationData.language.print;
    this.marcLink = options.marcLink || "";

    this.doc = null;
    this.docName = options.docName || "";

    this.dataTitle = options.dataTitle || null;

    this.divID = options.divID || null;

    this.list = {};
    this.templates = {};

    this.style = options.style || null;

    this.exportData = null;

    this.finalHTML = "";

    this.exportDataHTML = "";
    this.finalHTML = "";

    this.progressBar =
      "<div id='" +
      LS2PAC_CONSTANTS.Ids.printProgressbar +
      "'><p>" +
      ApplicationData.language.loading +
      "</p><div class='printProgressbar'></div></div>";
  }
  buildHTML(dataHTML) {
    this.finalHTML =
      '<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN" "http://www.w3.org/TR/html4/loose.dtd">' +
      "<html>" +
      "<head>" +
      "<title>" +
      this.docName +
      "</title>" +
      '<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />' +
      "<script>" +
      "	window.onunload = function(){" +
      "		if(window.opener){" +
      "			window.opener.onUserExit();" +
      "		}" +
      "	};" +
      "	window.printAndClose = function(){" +
      "		window.print();" +
      "		window.close();" +
      "	};" +
      "</script>" +
      "<style>" +
      "	html {font-family:arial; overflow-y:scroll; overflow-x:hidden;}" +
      "	body {margin:0px; padding:0px 0px 20px; }" +
      "	h1 {text-align:center;}" +
      "	#controlBar {position:fixed; bottom:0px; width:100%; height:24px; background:#CCCCCC; border-top:1px solid #333; font-size:14px; line-height:24px;}" +
      "	#format {position:relative; margin-left:5px; width:100px;}" +
      "	#printButton {position:absolute; right:5px; top:2px; *width:75px; line-height:16px; height:22px; padding: 0 5px; }" +
      "	#citations {padding:10px;}" +
      "	p.citation {text-indent:-50px; margin-left:50px;}" +
      "	span[quoted=true]:before {content: open-quote;}" +
      "	span[quoted=true]:after {content: close-quote;}" +
      "	thead {display:table-header-group;}" +
      "	th {text-align:left;}" +
      "	tbody {display:table-row-group;}" +
      "</style>" +
      '<style media="print">' +
      "	html {}" +
      "	body {}" +
      "	#controlBar {display:none;}" +
      "	p.citation {page-break-inside: avoid;}" +
      "</style>" +
      "</head>" +
      "<body>" +
      this.getAdditionalElements(dataHTML) +
      "</body>" +
      "</html>";
  }
  getAdditionalElements(dataHTML) {
    return (
      this.getControlBar() +
      this.getPrintButtons() +
      this.getFormat() +
      "</div>" +
      this.getDivID() +
      "<div>" +
      dataHTML +
      "</div>"
    );
  }
  getControlBar() {
    if (
      this.style
    ) {
      return '<div id="controlBar">';
    }
    return "<div>";
  }
  getPrintButtons() {
    return "";
  }
  getFormat() {
    if (this.style) {
      return (
        '<div id="format">' +
        ApplicationData.language.format +
        ": " +
        this.style +
        "</div>"
      );
    } else {
      return "";
    }
  }
  getDivID() {
    if (!this.divID) {
      return "<div>" + this.getDataTitle() + "</div>";
    } else {
      return '<div id="' + this.divID + '">' + this.getDataTitle() + "</div>";
    }
  }
  getDataTitle() {
    if (!this.dataTitle) {
      return "";
    } else {
      return "<h1>" + this.dataTitle + "</h1>";
    }
  }
  _openPopUp(callback) {
    //Dump to pop-up
    var _this = this;

    this.isOpen = true;

    if (document.all && this.popUpWindow !== null) {
      this.popUpWindow.close();
      this.popUpWindow = null;
    }

    if (callback) {
      callback();
    }
  }
  _closeWindow() {
    if (this.popUpWindow !== null) {
      this.popUpWindow.close();
      this.popUpWindow = null;
      this.isOpen = false;
    }
  }
  _setUpCloseFunction() {
    var _this = this;
    window.onUserExit = function () {
      _this._closeWindow();
    };
  }
  addListeners() {
    var _this = this;
    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onLogoutResponse,
      function (event) {
        if (window.isIE8 && _this.isOpen) {
          _this._closeWindow();
        } else if (_this.isOpen) {
          DialogManager.close();
        }
      }
    );
    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onGetFullListsForBibExportUpdate,
      function (event) {
        var percent = (event.data.current / event.data.total) * 100;
        $("#" + LS2PAC_CONSTANTS.Ids.printProgressbar)
          .find(".printProgressbar")
          .progressbar({
            value: percent,
          });
      }
    );
  }
  openPrintDialog(callback) {
    var _this = this;

    this.isOpen = true;

    if (window.isIE8) {
      _this._openPopUp(callback);
      _this._setUpCloseFunction();
    } else {
      DialogManager.show({
        content: this.progressBar + this.printFrame,
        dialogTitle: _this.dialogTitle,
        okText: ApplicationData.language.print,
        cancelText: ApplicationData.language.close,
        submitCallback: function () {
          if (document.all) {
            window.frames[_this.frameID].focus();
            window.frames[_this.frameID].print();
          } else {
            _this.doc.focus();
            _this.doc.print();
          }
        },
        closeCallback: function () {
          this.isOpen = false;
        },
        callback: function () {
          $(".dialogContentContainer input[type='submit']").addClass(
            LS2PAC_CONSTANTS.CssClasses.disabled
          );

          $("#" + LS2PAC_CONSTANTS.Ids.printProgressbar)
            .find(".printProgressbar")
            .progressbar({
              value: 5,
            });

          if (callback) {
            callback();
          }
        },
      });
    }
    _this.addListeners();
  }
  loadData() {
    //Dump to Dialog

      var iframe = document.getElementById(this.frameID);

      this.doc = iframe.contentWindow
        ? iframe.contentWindow
        : iframe.contentDocument.document
        ? iframe.contentDocument.document
        : iframe.contentDocument;

      this.doc.document.open();
      this.doc.document.write(this.finalHTML);
      this.doc.document.docName = this.docName;
      this.doc.document.close();
      //ASK: Can be false for IE11 -- .all
      if (this.doc.document.all) {
        window.frames[this.frameID].focus();
      } else {
        this.doc.focus();
      }
    

    $("#" + LS2PAC_CONSTANTS.Ids.printProgressbar).remove();

    $(".dialogContentContainer input[type='submit']").removeClass(
      LS2PAC_CONSTANTS.CssClasses.disabled
    );
  }
}
